/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type GradesDTO = {
  student: string;
  score: number;
  photo: string;
}


interface StudentsData {
scores: GradesDTO[];
  metaData: MetaData;
}

interface StudentsResponse {
  data?: StudentsData;
  error?: ApiError;
}

interface GetStudentsParams {
  page: number;
  limit: number;
  quizId:string
}

export const HostedQuizGrades = async ({ page, limit, quizId}: GetStudentsParams): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/quiz/getStudentQuizScoreByForExamHosting/${quizId}`, {
      params: { page, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
